import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)

import UserModules from './UserModules/index.js'
import CMS from './CMS/index.js'
import createPersistedState from 'vuex-persistedstate'

// ORM
import VuexORM from '@vuex-orm/core';
import VuexORMSearch from '@vuex-orm/plugin-search';
import Client from '@/store/ORM/client.js';
import Menu from '@/store/ORM/menu.js';
import Nutritionist from '@/store/ORM/nutritionists.js';
import PrivateNote from '@/store/ORM/private_notes.js';
import Event from '@/store/ORM/calendarevents.js';
import Test from '@/store/ORM/tests.js';
import InternalMessage from '@/store/ORM/messages.js';
import Supplier from '@/store/ORM/suppliers.js';
import Reference from '@/store/ORM/refferences.js';
import WeightHeightSet from '@/store/ORM/weightheightsets.js';
import CreatedMenu from '@/store/ORM/created-menu.js';
import Specialist from '@/store/ORM/specialists.js';
import Product from '@/store/ORM/products.js';
import Cart from '@/store/ORM/cart.js';
import Week from '@/store/ORM/weeks.js';

VuexORM.use(VuexORMSearch, {});
const database = new VuexORM.Database()

database.register(Nutritionist, 'nutritionists')
database.register(InternalMessage, 'messages')
database.register(Client, 'clients')
database.register(Menu, 'menus')
database.register(PrivateNote, 'private_notes')
database.register(Event, 'events')
database.register(Test, 'tests')
database.register(Supplier, 'suppliers')
database.register(Reference, 'references')
database.register(WeightHeightSet, 'weightheightsets')
database.register(CreatedMenu, 'created_menus')
database.register(Specialist, 'specialists')
database.register(Product, 'products')
database.register(Cart, 'carts')
database.register(Week, 'week')

const store = new Vuex.Store({
  modules: {
    UserModules,
    CMS
  },
  plugins: [
    VuexORM.install(database),
    createPersistedState()
  ],
});

export default store








